import type { CookieCategoryValue } from ".";

const getConsentedGroups: () => CookieCategoryValue[] = () => {
	if (typeof window.OnetrustActiveGroups !== 'string') {
		return [];
	}

	return window.OnetrustActiveGroups.split(',').filter(str => str) as CookieCategoryValue[];
}

export default getConsentedGroups;
